import React from 'react';
import { useLocation } from 'react-router-dom';

function useQuery(){
  return new URLSearchParams(useLocation().search);
}

export default function SearchResult() {
  const qry = useQuery();
  const searchQry = qry.get('qry');

  return (
    <div className="search-result-page">
        <div className="container">
          <div className="search-result-box">
            <div className="heading-box">
              <div className="flex jcsb">
                <div className="left-box">
                    <p><b><big>Search Query : </big></b>  {searchQry}</p>
                </div>
                <div className="right-box">
                  <h5>45 products</h5>
                </div>
              </div>
                <hr />
            </div>
          </div>
            <div className="products-box">
              <div className="row ProductItemContainer">
                <div className="prductListGrid">
                  <div className="ProductItem"><img src="" alt="" /></div>
                </div>
              </div>
            </div>
        </div>
    </div>
  )
}
